define.alias("shared/helpers/format-currency", "calendar/helpers/format-currency");